import { Open_Sans, Raleway } from "next/font/google";
const raleway_font = Raleway({ subsets: ['latin'] });
const open_sans_font = Open_Sans({ subsets: ['latin'] });

const open_sans = open_sans_font.style.fontFamily;
const raleway = raleway_font.style.fontFamily;

export { open_sans, raleway };
